import { useContext, useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { DestinationContext } from '../contexts/DestinationContext';
import { initializeAnalytics, trackPageView } from '../utils/analytics';

export default function Analytics() {
    const destination = useContext(DestinationContext);
    const location = useLocation();

    useEffect(() => {
        if (!destination?.gaid) {
            return;
        }

        initializeAnalytics(destination.gaid);
    }, [destination?.gaid]);

    useEffect(() => {
        if (!destination?.gaid || !location?.pathname) {
            return;
        }

        trackPageView(location.pathname + (location.searchStr || ''));
    }, [location?.pathname, location?.searchStr, destination?.gaid]);

    return null;
}
